import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'modalCssHelper',
    standalone: false
})
export class ModalCssHelperPipe implements PipeTransform {

  transform(value: string): string {
    switch (value) {
      case 'alert':
        return "alert-message";
      case 'warning':
        return "warning-message";
      case 'success':
        return "success-message";
    }
    return '';
  }

}
